export default __webpack_public_path__ + "static/media/271.961ec052.png";